import { createBrowserRouter } from 'react-router-dom'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import {
  DashboardPage,
  DigitalQRPage,
  GeneratePostsPage,
  GmbAiAgentPage,
  GmbAiListingPage,
  GmbCreatePostPage,
  GmbKeywordsPage,
  GmbMediaPage,
  GmbOptimizationPage,
  GmbPerformancePage,
  GmbPostsPage,
  GmbReviewsPage,
  GmbSchedulePage,
  GoogleAuditPage,
  GoogleAutomationPage,
  NotFoundPage,
  PlansPage,
  SettingsPage,
  WebsitePage,
} from '@/app/lazyPages'
import { ROUTES } from '@/utils/constants'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: ROUTES.DIGITAL_QR.slice(1), element: <DigitalQRPage /> },
      {
        path: ROUTES.GOOGLE_AUTOMATION.slice(1),
        element: <GoogleAutomationPage />,
      },
      { path: ROUTES.GMB_AI_AGENT.slice(1), element: <GmbAiAgentPage /> },
      {
        path: ROUTES.GMB_OPTIMIZATION.slice(1),
        element: <GmbOptimizationPage />,
      },
      { path: ROUTES.GMB_REVIEWS.slice(1), element: <GmbReviewsPage /> },
      { path: ROUTES.GMB_SCHEDULE.slice(1), element: <GmbSchedulePage /> },
      { path: ROUTES.GMB_POSTS.slice(1), element: <GmbPostsPage /> },
      {
        path: ROUTES.GMB_CREATE_POST.slice(1),
        element: <GmbCreatePostPage />,
      },
      { path: ROUTES.GMB_MEDIA.slice(1), element: <GmbMediaPage /> },
      { path: ROUTES.GMB_KEYWORDS.slice(1), element: <GmbKeywordsPage /> },
      {
        path: ROUTES.GMB_PERFORMANCE.slice(1),
        element: <GmbPerformancePage />,
      },
      { path: ROUTES.GMB_AI_LISTING.slice(1), element: <GmbAiListingPage /> },
      { path: ROUTES.GOOGLE_AUDIT.slice(1), element: <GoogleAuditPage /> },
      { path: ROUTES.AI_POSTS.slice(1), element: <GeneratePostsPage /> },
      { path: ROUTES.WEBSITE.slice(1), element: <WebsitePage /> },
      { path: ROUTES.NEED_HELP.slice(1), element: <PlansPage /> },
      { path: ROUTES.SETTINGS.slice(1), element: <SettingsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
